import {z} from 'zod';
import {zDateTime} from '@brunata-angular/util';

export type Interval = 'H' | 'D' | 'M' | 'Y';

export const allocationUnitStatusSchema = z.object({
    allocationUnit: z.string(),
    isActive: z.boolean(),
    lastDismountedDate: zDateTime.nullable(),
});

export type AllocationUnitStatus = z.infer<typeof allocationUnitStatusSchema>;

export const consumptionDataSchema = z.object({
    startDate: zDateTime,
    endDate: zDateTime,
    consumptionLines: z.array(
        z.object({
            meter: z.object({
                meterId: z.number(),
                placement: z.string().nullable(),
                meterNo: z.string(),
                meterType: z.number(),
                scale: z.number().nullable(),
                unitfactor: z.number().nullable(),
                unitReduction: z.number().nullable().optional(),
                mountingDate: zDateTime.nullable(),
                dismountedDate: zDateTime.nullable(),
                transmitting: z.boolean(),
                allocationUnit: z.string(),
                superAllocationUnit: z.number().nullable(),
                unit: z.string(),
                meterSequenceNo: z.number(),
                numerator: z.unknown().nullable(),
                denominator: z.unknown().nullable(),
                decimals: z.number().default(0),
            }),
            consumptionValues: z.array(
                z.object({
                    fromDate: zDateTime,
                    toDate: zDateTime,
                    consumption: z.number().nullable(),
                }),
            ),
        }),
    ),
});

export type ConsumptionData = z.infer<typeof consumptionDataSchema>;
